import { findIana } from 'windows-iana'
import moment from 'moment-timezone'

import './locales/en-001'
import './locales/en-029'
import './locales/en-150'
// import './locales/en-as'
import './locales/en-ai'
import './locales/en-ag'
import 'moment/locale/en-au'
import './locales/en-at'
import './locales/en-bs'
import './locales/en-bb'
import './locales/en-be'
import './locales/en-bz'
import './locales/en-bm'
import './locales/en-bw'
import './locales/en-io'
import './locales/en-vg'
import './locales/en-bi'
import './locales/en-cm'
import 'moment/locale/en-ca'
import './locales/en-ky'
import './locales/en-cx'
import './locales/en-cc'
import './locales/en-ck'
import './locales/en-cy'
import './locales/en-dk'
import './locales/en-dm'
import './locales/en-er'
import './locales/en-fk'
import './locales/en-fj'
import './locales/en-fi'
import './locales/en-gm'
import './locales/en-de'
import './locales/en-gh'
import './locales/en-gi'
import './locales/en-gd'
import './locales/en-gu'
import './locales/en-gg'
import './locales/en-gy'
import './locales/en-hk'
import 'moment/locale/en-in'
import './locales/en-id'
import 'moment/locale/en-ie'
import './locales/en-im'
import 'moment/locale/en-il'
import './locales/en-jm'
import './locales/en-je'
import './locales/en-ke'
import './locales/en-ki'
import './locales/en-ls'
import './locales/en-lr'
import './locales/en-mo'
import './locales/en-mg'
import './locales/en-mw'
import './locales/en-my'
import './locales/en-mt'
import './locales/en-mh'
import './locales/en-mu'
import './locales/en-fm'
import './locales/en-ms'
import './locales/en-na'
import './locales/en-nr'
import './locales/en-nl'
import 'moment/locale/en-nz'
import './locales/en-ng'
import './locales/en-nu'
import './locales/en-nf'
import './locales/en-mp'
import './locales/en-pk'
import './locales/en-pw'
import './locales/en-pg'
import './locales/en-ph'
import './locales/en-pn'
import './locales/en-pr'
import './locales/en-rw'
import './locales/en-kn'
import './locales/en-lc'
import './locales/en-vc'
// import './locales/en-ws'
import './locales/en-sc'
import './locales/en-sl'
import 'moment/locale/en-sg'
import './locales/en-sx'
import './locales/en-si'
import './locales/en-sb'
import './locales/en-za'
import './locales/en-ss'
import './locales/en-sh'
import './locales/en-sd'
import './locales/en-sz'
import './locales/en-se'
import './locales/en-ch'
import './locales/en-tz'
import './locales/en-tk'
import './locales/en-to'
import './locales/en-tt'
import './locales/en-tc'
import './locales/en-tv'
import './locales/en-um'
import './locales/en-vi'
import './locales/en-ug'
import 'moment/locale/en-gb'
import './locales/en-vu'
import './locales/en-zm'
import './locales/en-zw'

import { localeSetting } from '~/redux/features/settings/settingSlice'
import { useAppSelector } from '~/app/hooks'
import { EFLocalDateTimeModel } from './EFLocalTime.model'


export function LocalTimeText(
  isoDateTimeString: string,
  displayFormat: string,
  timezone?: string,
  locale?: string
): string {
  let resolvedDisplayString = ''

  if (isoDateTimeString) {
    // The timezone stored in EnableFleet is in Microsoft Timezone format, moment needs IANA identifer
    const microsoftTimezone = timezone ?? ''
    const ianaIdentifier = microsoftTimezone
      ? findIana(microsoftTimezone)?.[0] ?? null
      : null
    const momentDate = ianaIdentifier
      ? moment(isoDateTimeString).tz(ianaIdentifier)
      : moment.utc(isoDateTimeString)

    const resolvedLocale: string = locale?.toLocaleLowerCase() ?? 'en'
    momentDate.locale(resolvedLocale)
    resolvedDisplayString = momentDate.format(displayFormat)
  }
  return resolvedDisplayString
}
export const defaultMomentFormat = 'L LTS'

export function EFLocalDateTime({
  displayFormat,
  isoDateTimeString
}: EFLocalDateTimeModel) {
  const localeTime = useAppSelector(localeSetting)
  return (
    <>
      {LocalTimeText(
        isoDateTimeString ?? '',
        displayFormat ?? defaultMomentFormat,
        localeTime.timezone,
        localeTime.locale
      )}
    </>
  )
}
